import { RecordValue, NumberValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload, requiredEmptyAllowedString, } from '../../../../utils/validate-payload.js';
import { facetIdDefinition } from '../../generic/facet-actions-validation.js';
import { facetSearchOptionsDefinition } from '../generic/generic-facet-search-validate-payload.js';
const selectFacetSearchResultPayloadDefinition = {
    facetId: facetIdDefinition,
    value: new RecordValue({
        values: {
            displayValue: requiredEmptyAllowedString,
            rawValue: requiredEmptyAllowedString,
            count: new NumberValue({ required: true, min: 0 }),
        },
    }),
};
export const registerFacetSearch = createAction('facetSearch/register', (payload) => validatePayload(payload, facetSearchOptionsDefinition));
export const updateFacetSearch = createAction('facetSearch/update', (payload) => validatePayload(payload, facetSearchOptionsDefinition));
export const selectFacetSearchResult = createAction('facetSearch/toggleSelectValue', (payload) => validatePayload(payload, selectFacetSearchResultPayloadDefinition));
export const excludeFacetSearchResult = createAction('facetSearch/toggleExcludeValue', (payload) => validatePayload(payload, selectFacetSearchResultPayloadDefinition));
